import { format, isValid, parseISO } from 'date-fns'

/**
 *
 * Take a Date or Timestamp as input and format according to passed format
 * @param  {Object|Number|String} input
 * @param  {String} dateFormat
 * @returns {Boolean|String}
 */
export const formatDate = (input, dateFormat = 'dd.MM.yyyy') => {
  if (!input || !dateFormat) return false
  if (input[2] === '.') {
    const chunks = input.split('.')
    input = `${chunks[2]}-${chunks[1]}-${chunks[0]}`
  }

  const isoFormat = parseISO(input)
  return isValid(isoFormat) ? format(parseISO(input), dateFormat) : false
}

/**
 * Return the age
 * @param  {String} input A birthdate formatted like this yyyy-MM-dd
 * @return {Number}
 */
export const getAge = input => {
  const formattedInput = formatDate(input, 'yyyy-MM-dd')
  if (!formattedInput) {
    return
  }

  const birthDate = new Date(formattedInput)
  const today = new Date()

  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}
